import amplitude from './amplitude'
import intercom from '../Intercom'

const consumers = [amplitude, intercom]

export default consumers
